export const VITE_ACCOUNTS_PROFILE_API_URL = import.meta.env.VITE_ACCOUNTS_PROFILE_API_URL;
export const VITE_ACCOUNTS_URL = import.meta.env.VITE_ACCOUNTS_URL;
export const VITE_ACCOUNT_MANAGEMENT_KEY = import.meta.env.VITE_ACCOUNT_MANAGEMENT_KEY;
export const VITE_API = import.meta.env.VITE_API;
export const VITE_ATTACH_CASE_KEY = import.meta.env.VITE_ATTACH_CASE_KEY;
export const VITE_AUTHORITY = import.meta.env.VITE_AUTHORITY;
export const VITE_AUTHORITY_CITI = import.meta.env.VITE_AUTHORITY_CITI;
export const VITE_AUTHORITY_EVO = import.meta.env.VITE_AUTHORITY_EVO;
export const VITE_AUTHORITY_HPY = import.meta.env.VITE_AUTHORITY_HPY;
export const VITE_AUTH_API = import.meta.env.VITE_AUTH_API;
export const VITE_AUTH_DATE_KEY = import.meta.env.VITE_AUTH_DATE_KEY;
export const VITE_AUTH_HEADER_PREFIX = import.meta.env.VITE_AUTH_HEADER_PREFIX;
export const VITE_AVAILABLE_QUEUES = import.meta.env.VITE_AVAILABLE_QUEUES;
export const VITE_AX_CARD_BRAND_LIMIT = import.meta.env.VITE_AX_CARD_BRAND_LIMIT;
export const VITE_CASE_ACTION_API = import.meta.env.VITE_CASE_ACTION_API;
export const VITE_CASE_DATA2_API = import.meta.env.VITE_CASE_DATA2_API;
export const VITE_CASE_DATA_API = import.meta.env.VITE_CASE_DATA_API;
export const VITE_CASE_HISTORY_API = import.meta.env.VITE_CASE_HISTORY_API;
export const VITE_CASE_MANAGER_API = import.meta.env.VITE_CASE_MANAGER_API;
export const VITE_CITI_BRANDED_URL = import.meta.env.VITE_CITI_BRANDED_URL;
export const VITE_CITI_REPORTING_APPLICATION_URL = import.meta.env.VITE_CITI_REPORTING_APPLICATION_URL;
export const VITE_CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
export const VITE_CLIENT_ID_ACCOUNTS = import.meta.env.VITE_CLIENT_ID_ACCOUNTS;
export const VITE_CLIENT_ID_CITI = import.meta.env.VITE_CLIENT_ID_CITI;
export const VITE_CLIENT_ID_CITI_ACCOUNTS = import.meta.env.VITE_CLIENT_ID_CITI_ACCOUNTS;
export const VITE_CLIENT_ID_EVO = import.meta.env.VITE_CLIENT_ID_EVO;
export const VITE_CLIENT_ID_HPY = import.meta.env.VITE_CLIENT_ID_HPY;
export const VITE_CQ_FILTERS_SEARCH_TYPE_ID = import.meta.env.VITE_CQ_FILTERS_SEARCH_TYPE_ID;
export const VITE_CUSTOMER_ENGAGEMENT_URL = import.meta.env.VITE_CUSTOMER_ENGAGEMENT_URL;
export const VITE_DAI_AP_CAMPAIGN_END_DATE = import.meta.env.VITE_DAI_AP_CAMPAIGN_END_DATE;
export const VITE_DAI_CA_CAMPAIGN_END_DATE = import.meta.env.VITE_DAI_CA_CAMPAIGN_END_DATE;
export const VITE_DAI_EU_CAMPAIGN_END_DATE = import.meta.env.VITE_DAI_EU_CAMPAIGN_END_DATE;
export const VITE_DAI_US_CAMPAIGN_END_DATE = import.meta.env.VITE_DAI_US_CAMPAIGN_END_DATE;
export const VITE_DEFAULT_LETTER_TEMPLATE_LANGUAGE_ID = import.meta.env.VITE_DEFAULT_LETTER_TEMPLATE_LANGUAGE_ID;
export const VITE_DETAIL_DRAWER_KEY = import.meta.env.VITE_DETAIL_DRAWER_KEY;
export const VITE_DIMS_CASE_VALIDATOR_API = import.meta.env.VITE_DIMS_CASE_VALIDATOR_API;
export const VITE_DIMS_URL = import.meta.env.VITE_DIMS_URL;
export const VITE_DI_CARD_BRAND_LIMIT = import.meta.env.VITE_DI_CARD_BRAND_LIMIT;
export const VITE_DOCUMENTS_API = import.meta.env.VITE_DOCUMENTS_API;
export const VITE_DiMS_INTERNAL_EMPLOYEE = import.meta.env.VITE_DiMS_INTERNAL_EMPLOYEE;
export const VITE_EVO_BRANDED_URL = import.meta.env.VITE_EVO_BRANDED_URL;
export const VITE_EXPORT_FILE_ROW_LIMIT = import.meta.env.VITE_EXPORT_FILE_ROW_LIMIT;
export const VITE_EXPORT_URL = import.meta.env.VITE_EXPORT_URL;
export const VITE_FILTER_AND_DEC = import.meta.env.VITE_FILTER_AND_DEC;
export const VITE_GA4_PROPERTY = import.meta.env.VITE_GA4_PROPERTY;
export const VITE_GA4_PROPERTY_CITI = import.meta.env.VITE_GA4_PROPERTY_CITI;
export const VITE_GA4_PROPERTY_GPN = import.meta.env.VITE_GA4_PROPERTY_GPN;
export const VITE_GA4_PROPERTY_HPY = import.meta.env.VITE_GA4_PROPERTY_HPY;
export const VITE_GA_DEBUG = import.meta.env.VITE_GA_DEBUG;
export const VITE_GA_PROPERTY = import.meta.env.VITE_GA_PROPERTY;
export const VITE_GENERICBANNERVISIBLE = import.meta.env.VITE_GENERICBANNERVISIBLE;
export const VITE_GP_VERSION = import.meta.env.VITE_GP_VERSION;
export const VITE_GP_VERSION_DATAPOWER_API = import.meta.env.VITE_GP_VERSION_DATAPOWER_API;
export const VITE_HPY_BRANDED_URL = import.meta.env.VITE_HPY_BRANDED_URL;
export const VITE_IMAGE_MATCHER_API = import.meta.env.VITE_IMAGE_MATCHER_API;
export const VITE_IMAGE_MATCH_QUEUES = import.meta.env.VITE_IMAGE_MATCH_QUEUES;
export const VITE_IMAGE_READER_API = import.meta.env.VITE_IMAGE_READER_API;
export const VITE_IMAGE_READER_DATAPOWER_API = import.meta.env.VITE_IMAGE_READER_DATAPOWER_API;
export const VITE_INTERNAL_ADMIN_KEY = import.meta.env.VITE_INTERNAL_ADMIN_KEY;
export const VITE_JWT_SCOPE = import.meta.env.VITE_JWT_SCOPE;
export const VITE_LOCK_CASE_TIME_INTERVAL = import.meta.env.VITE_LOCK_CASE_TIME_INTERVAL;
export const VITE_LOGROCKET_APP_ID = import.meta.env.VITE_LOGROCKET_APP_ID;
export const VITE_LOGROCKET_INGEST_SERVER = import.meta.env.VITE_LOGROCKET_INGEST_SERVER;
export const VITE_LOGROCKET_SKD_SERVER = import.meta.env.VITE_LOGROCKET_SKD_SERVER;
export const VITE_MAINTENANCE_LOGIN_TOKEN = import.meta.env.VITE_MAINTENANCE_LOGIN_TOKEN;
export const VITE_MAINTENANCE_REASON = import.meta.env.VITE_MAINTENANCE_REASON;
export const VITE_MAINTENANCE_TILL = import.meta.env.VITE_MAINTENANCE_TILL;
export const VITE_MAINTENANCE_TITLE = import.meta.env.VITE_MAINTENANCE_TITLE;
export const VITE_MAX_ALLOWED_OPEN_CASE_LIMIT = import.meta.env.VITE_MAX_ALLOWED_OPEN_CASE_LIMIT;
export const VITE_MC_CARD_BRAND_LIMIT = import.meta.env.VITE_MC_CARD_BRAND_LIMIT;
export const VITE_MERCHANT_APPLICATION_URL = import.meta.env.VITE_MERCHANT_APPLICATION_URL;
export const VITE_MERCHANT_HELP_URL = import.meta.env.VITE_MERCHANT_HELP_URL;
export const VITE_MERCHANT_IMAGE_QUEUE = import.meta.env.VITE_MERCHANT_IMAGE_QUEUE;
export const VITE_MERCHANT_NUMBER_KEY = import.meta.env.VITE_MERCHANT_NUMBER_KEY;
export const VITE_MESSAGES_API = import.meta.env.VITE_MESSAGES_API;
export const VITE_MOCK_API = import.meta.env.VITE_MOCK_API;
export const VITE_NODE_ENV = import.meta.env.VITE_NODE_ENV;
export const VITE_NOTIFICATION_PREFERENCE_API = import.meta.env.VITE_NOTIFICATION_PREFERENCE_API;
export const VITE_OP1CASESELECTION = import.meta.env.VITE_OP1CASESELECTION;
export const VITE_PCI_URL = import.meta.env.VITE_PCI_URL;
export const VITE_PENDO_JWT_KEY = import.meta.env.VITE_PENDO_JWT_KEY;
export const VITE_PRODUCTIVITY_REPORT_SEARCH_TYPE_ID = import.meta.env.VITE_PRODUCTIVITY_REPORT_SEARCH_TYPE_ID;
export const VITE_QUEUE_MANAGER_API = import.meta.env.VITE_QUEUE_MANAGER_API;
export const VITE_QUEUE_MGMT_QUEUES = import.meta.env.VITE_QUEUE_MGMT_QUEUES;
export const VITE_RECENT_CASE_LIMIT = import.meta.env.VITE_RECENT_CASE_LIMIT;
export const VITE_REFERENCE_DATA_DATA_API = import.meta.env.VITE_REFERENCE_DATA_DATA_API;
export const VITE_REPORTBANNERVISIBLE = import.meta.env.VITE_REPORTBANNERVISIBLE;
export const VITE_REPORTING_APPLICATION_MIGRATED_URL = import.meta.env.VITE_REPORTING_APPLICATION_MIGRATED_URL;
export const VITE_REPORTING_APPLICATION_URL = import.meta.env.VITE_REPORTING_APPLICATION_URL;
export const VITE_REPORTS_API = import.meta.env.VITE_REPORTS_API;
export const VITE_REPORTS_API_V2 = import.meta.env.VITE_REPORTS_API_V2;
export const VITE_REPORTS_KEY = import.meta.env.VITE_REPORTS_KEY;
export const VITE_REPORT_DATA_API = import.meta.env.VITE_REPORT_DATA_API;
export const VITE_REPORT_MANAGER_API = import.meta.env.VITE_REPORT_MANAGER_API;
export const VITE_SCHEDULE_API = import.meta.env.VITE_SCHEDULE_API;
export const VITE_SCHEME_IMAGE_QUEUE = import.meta.env.VITE_SCHEME_IMAGE_QUEUE;
export const VITE_SEARCH_FILTER_URL = import.meta.env.VITE_SEARCH_FILTER_URL;
export const VITE_SHAREBANNERVISIBLE = import.meta.env.VITE_SHAREBANNERVISIBLE;
export const VITE_STATEMENTS_API = import.meta.env.VITE_STATEMENTS_API;
export const VITE_SUCCESSBANNERVISIBLE = import.meta.env.VITE_SUCCESSBANNERVISIBLE;
export const VITE_TOKENIZATION_API = import.meta.env.VITE_TOKENIZATION_API;
export const VITE_TOKEN_TYPE = import.meta.env.VITE_TOKEN_TYPE;
export const VITE_TRANSACTION_DATE_KEY = import.meta.env.VITE_TRANSACTION_DATE_KEY;
export const VITE_TRANSACTION_UNMATCHED_QUEUE = import.meta.env.VITE_TRANSACTION_UNMATCHED_QUEUE;
export const VITE_TYPE_AND_DESC = import.meta.env.VITE_TYPE_AND_DESC;
export const VITE_UNRESOLVE_RTI_SEARCH_TYPE_ID = import.meta.env.VITE_UNRESOLVE_RTI_SEARCH_TYPE_ID;
export const VITE_USERS_ACTIVITY_MANAGER_API = import.meta.env.VITE_USERS_ACTIVITY_MANAGER_API;
export const VITE_USERS_API = import.meta.env.VITE_USERS_API;
export const VITE_USER_MANAGER_API = import.meta.env.VITE_USER_MANAGER_API;
export const VITE_USE_MOCK = import.meta.env.VITE_USE_MOCK;
export const VITE_VIRTUAL_TERMINAL_URL = import.meta.env.VITE_VIRTUAL_TERMINAL_URL;
export const VITE_VI_CARD_BRAND_LIMIT = import.meta.env.VITE_VI_CARD_BRAND_LIMIT;
export const VITE_authority = import.meta.env.VITE_authority || '';
export const VITE_client_id = import.meta.env.VITE_client_id || '';
export const VITE_POST_LOGOUT_REDIRECT_URL = import.meta.env.VITE_POST_LOGOUT_REDIRECT_URL;
export const VITE_GPE_BRANDED_URL = import.meta.env.VITE_GPE_BRANDED_URL;

/* ------------- Static Constants ------------------ */

export const VITE_EDGE = window.navigator.userAgent.indexOf('Edge') > -1;
export const VITE_MSIE11 = window.navigator.userAgent.indexOf('Trident/7.0') > -1;
export const VITE_NEW_AUTH_TOKEN_TIME = 60 * 30 * 1000;
export const VITE_RENEW_AUTH_TOKEN_TIME = 60 * 15 * 1000;
export const VITE_isEdge = navigator.userAgent.toLowerCase().indexOf('edge') >= 0;
export const VITE_isFirefox = typeof InstallTrigger !== 'undefined';
export const VITE_isIE = /* @cc_on!@ */false || !!document.documentMode;
